<template>
  <div :class="divClass">
    <label :for="forLabel" :class="labelClass">{{ label }}</label>
    <input
      :type="type"
      :class="inputClass"
      :id="idInput"
      :placeholder="placeholder"
      :value="value"
      :required="required"
      :disabled="disabled"
    />
  </div>
</template>
<script>
export default {
  props: {
    divClass: String,
    type: String,
    inputClass: String,
    idInput: String,
    forLabel: String,
    labelClass: String,
    label: String,
    placeholder: String,
    value: String,
    required: Boolean,
    disabled: Boolean
  },
};
</script>
